import { render } from "./modalSelectAllotmentComponent.vue?vue&type=template&id=0f09856d"
import script from "./modalSelectAllotmentComponent.vue?vue&type=script&lang=js"
export * from "./modalSelectAllotmentComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__